var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { IconWrapper } from ".";
export const CountryIcon = React.forwardRef((_a, ref) => {
    var { color = "primary" } = _a, otherProps = __rest(_a, ["color"]);
    return (React.createElement(IconWrapper, Object.assign({ ref: ref, width: 24, height: 24, color: color }, otherProps),
        React.createElement("path", { d: "M5 2C4.44772 2 4 2.44772 4 3V20H3C2.44772 20 2 20.4477 2 21C2 21.5523 2.44772 22 3 22H7C7.55228 22 8 21.5523 8 21C8 20.4477 7.55228 20 7 20H6V3C6 2.44772 5.55228 2 5 2Z" }),
        React.createElement("path", { d: "M7 4H12C12.5523 4 13 4.44772 13 5V6H18C18.5523 6 19 6.44772 19 7V13C19 13.5523 18.5523 14 18 14H14C13.4477 14 13 13.5523 13 13V12H7V4Z" })));
});
//# sourceMappingURL=Country.js.map